import { useApolloClient } from '@apollo/client/react';
import { useAuth } from '@teamexos/fit-shared';
import { useCallback } from 'react';

const useLogout = () => {
  const client = useApolloClient();
  const { signOut } = useAuth();

  const logout = useCallback(async () => {
    await signOut(false);
    await client.clearStore();
  }, [client, signOut]);

  return logout;
};

export default useLogout;
